import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

class CustomHandoffEventMessageRecord extends BaseMessageRecord({
  type: "custom_handoff_event"
}) {
  /**
   * Validation
   */

  /**
   * @returns {Immutable.List.<String>}
   */
  static getInvalidFields = () => Immutable.List();
}


export default CustomHandoffEventMessageRecord;
